import React, { useState } from "react";
import styled from "@emotion/styled";
import {
  Box,
  Popover as MuiPopover,
  Typography,
  Button as MuiButton,
  CircularProgress,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../redux/slices/snackbar";
import { generalErrorMessage } from "../pages/flotta/constant";

const Popover = styled(MuiPopover)`
  .MuiPaper-root {
    width: 300px;
    padding: 16px;
    ${(props) => props.theme.shadows[1]};
    border: 1px solid ${(props) => props.theme.palette.divider};
  }
`;

const ContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const FlexBox = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;
`;

const ButtonBox = styled(Box)`
  display: flex;
  gap: "16px";
  width: 100%;
  justify-content: center;
  margin-top: 16px;
`;

const Button = styled(MuiButton)`
  margin: 0 8px;
`;

/**
 * PopoverRebootCustom
 *
 * A confirmation popover that delegates the reboot action to a custom
 * function passed via the `onConfirm` prop, instead of calling
 * `rcAutoNewUpdate` internally.
 *
 * Props:
 * - isRebootPopoverOpen {boolean} — whether the popover is visible
 * - handleCloseRebootPopup {function} — called when the user clicks "No" or closes
 * - rebootRef {Element} — anchor element for the popover
 * - onConfirm {function} — async function to call on confirmation;
 *     should return { status: 1|0, message: string }
 * - refreshData {function} — optional callback to refresh the parent data on success
 */
function PopoverRebootCustom({
  isRebootPopoverOpen,
  handleCloseRebootPopup,
  rebootRef,
  onConfirm,
}) {
  const handleReboot = async () => {
    if (!onConfirm) return;
    await onConfirm();
  };

  return (
    <Popover
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      anchorEl={rebootRef}
      onClose={handleCloseRebootPopup}
      open={isRebootPopoverOpen}
    >
      <ContentBox>
        <FlexBox>
          <Typography variant="body2" sx={{ marginTop: "8px" }}>
            Si desidera eseguire nuovamente la ricerca per la targa selezionata?
          </Typography>
        </FlexBox>
        <ButtonBox>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCloseRebootPopup}
          >
            No
          </Button>
          <Button variant="contained" color="primary" onClick={handleReboot}>
            Si
          </Button>
        </ButtonBox>
      </ContentBox>
    </Popover>
  );
}

export default PopoverRebootCustom;
